module.exports = __webpack_public_path__ + "static/media/pallet_revendedor.258c2106.jpg";